enum CHECKOUT_PAYMENT_INTENT_UPDATE_ERROR_RESULT {
    taxErrorHandled = 'taxErrorHandled',
    genericErrorHandled = 'genericErrorHandled',
}

export { CHECKOUT_PAYMENT_INTENT_UPDATE_ERROR_RESULT };
